<template>
    <div class="pp-content">
        <div class="pp-header pp-header--simple pp-header--image-generic">
            <div class="pp-header__title">
                Pristine Streaming
            </div>
            <div class="pp-header__content">
                Welcome to Pristine Streaming: the best historic recordings, streamed in pristine high resolution sound.
            </div>
        </div>
        <div class="pp-content__page">
            <div class="pp-tabs">
                <ul class="pp-tabs__headers">
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse">
                            Popular
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/albums">
                            Albums
                        </router-link>
                    </li>
                    <li v-if="$root.view != 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/tracks">
                            Tracks
                        </router-link>
                    </li>
                    <li v-if="$root.view == 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/new">
                            New
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/composers">
                            Composers
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/ensembles">
                            Ensembles
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/artists">
                            Artists
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/exclusive">
                            Exclusives
                        </router-link>
                    </li>
                    <li v-if="$root.view == 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/tracks">
                            Tracks
                        </router-link>
                    </li>
                </ul>
                <div class="pp-welcome">
                    <div v-if="!$root.account.id || !$root.account.plan" class="pp-welcome__left">
                        <div class="pp-welcome__header">
                            Get started
                        </div>
                        <p v-if="!$root.account.id && !$root.account.plan" class="pp-welcome__paragraph">
                            If you're already a Pristine Streaming subscriber, simply click the button
                            below to log in.
                        </p>
                        <p v-if="$root.account.id && !$root.account.plan" class="pp-welcome__paragraph">
                            If you're not yet a Pristine Streaming subscriber, simply click the button
                            below to subscribe.
                        </p>
                        <p v-if="!$root.account.id && !$root.account.plan && !$root.isIos" class="pp-welcome__paragraph">
                            Not subscribed yet? Subscribing only take a couple of seconds
                            and gives you access to our entire library.
                        </p>
                        <p v-if="$root.account.id && !$root.account.plan" class="pp-welcome__paragraph">
                            Subscribing only take a couple of seconds
                            and gives you access to our entire library.
                        </p>

                        <a v-if="!$root.account.id && !$root.account.plan" class="pp-welcome__button" :href="'https://www.pristineclassical.com/pages/player-subscribe?mode='+$root.view+'&signin_hidden='+($root.isIos ? 'true' : 'false')">
                            Login with your Pristine Classical account
                        </a>

                        <div v-if="!$root.isIos">
                            <a v-if="$root.account.id && !$root.account.plan" class="pp-welcome__button" :href="'https://www.pristineclassical.com/pages/player-subscribe?mode='+$root.view">
                                Subscribe to Pristine Streaming
                            </a>
                        </div>

                        <router-link class="pp-welcome__button pp-welcome__button--secondary" to="/browse">
                            Browse and listen for free
                        </router-link>

    <!--
                        <div style="border: 3px double black;text-align: left;margin:20px 0;padding:10px;">
                            <strong>Attention</strong>
                            <br>
                            A few albums from our old library haven't been imported yet, so you may notice some
                            missing tracks. We're currently working to import these, but in the meantime please
                            enjoy the >.
                            <br>
                            <br>
                            We hope you'll love using the new player.
                            If you notice any issues, please get in touch at:
                            <a href="mailto:andrew@pristineaudio.com">andrew@pristineaudio.com</a>
                        </div>
                    -->
                    </div>
                    <div v-if="$root.account.id && $root.account.plan" class="pp-welcome__left">
                        <div class="pp-welcome__header">
                            Start exploring
                        </div>
                        <p class="pp-welcome__paragraph">
                            <strong>Thanks for subscribing to Pristine Streaming!</strong>
                        </p>
                        <p class="pp-welcome__paragraph">
                            Your subscription gives you unlimited access to our entire library.
                            To start exploring, use the links in the sidebar.
                        </p>
                        <p class="pp-welcome__paragraph">
                            If you have any questions or technical issues with the service, please contact
                            <a href="mailto:andrew@pristineaudio.com">
                                andrew@pristineaudio.com
                            </a> for support.
                        </p>
                    </div>
                    <div v-if="!$root.account.id || !$root.account.plan"  class="pp-welcome__right">

                        <div class="pp-welcome__header">
                            What's available?
                        </div>
                        <ul class="pp-welcome__checklist">
                            <li>The greatest library of historic classical music at your fingertips.</li>
                            <!--
                            <li><strong>11,000</strong> unique, remastered classics.</li>
                            -->
                            <li><strong>12,000+</strong> unique, remastered classics.</li>
                            <li><strong>2,500+</strong> composers, ensembles, and artists.</li>
                            <li><strong>1,000</strong> exclusive Pristine Streaming tracks.</li>
                            <li>Listen in either 320kbps MP3 or <strong>high-quality FLAC</strong>.</li>
                        </ul>
                        <p class="pp-welcome__paragraph">
                            FLAC streaming available on the latest versions of Google Chrome, Mozilla Firefox or Microsoft Edge.
                        </p>


                        <br>
                    </div>
                    <div class="pp-welcome__row">
                        <div v-if="!$root.account.id || !$root.account.plan">
                            <br><br>
                            <div class="pp-welcome__header">
                                Try it for free
                            </div>
                            <p class="pp-welcome__paragraph">
                                To get a taste of the huge selection available, you can play up to five
                                tracks completely free: no registration required.
                            </p>
                            <p class="pp-welcome__paragraph">
                                Give it a try with one of the tracks below, or start exploring our library:
                            </p>
                            <loading-indicator v-if="loadingTracks"></loading-indicator>
                            <track-list v-if="tracks.length > 0" :items="tracks"></track-list>
                            <router-link class="pp-welcome__button pp-welcome__button--secondary" to="/browse">
                                Start exploring
                            </router-link>
                        </div>
                    </div>

    <!--
                    <div v-if="$root.account.id && $root.account.plan" class="pp-welcome__right">
                        <div style="border: 3px double black;text-align: left;margin:20px 0;padding:10px;">
                            <strong>Attention</strong>
                            <br>
                            A few albums from our old library haven't been imported yet, so you may notice some
                            missing tracks. We're currently working to import these, but in the meantime please
                            enjoy the >8,000 tracks already available.
                            <br>
                            <br>
                            We hope you'll love using the new player.
                            If you notice any issues, please get in touch at:
                            <a href="mailto:andrew@pristineaudio.com">andrew@pristineaudio.com</a>
                        </div>
                    </div>
                -->

                    <!--
                    <div v-if="$root.account.id && $root.account.plan" class="pp-welcome__right">
                        <div class="pp-welcome__header">
                            What's new?
                        </div>
                        <div class="pp-welcome__paragraph">

                            You can new play music using any Chromecast-supported device, including
                            speakers, Smart TVs, and more.
                            Just click the cast icon in the player controls to get started.

                        </div>
                    </div>
                    -->
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import TrackList from '../components/TrackList.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import { api } from '../API.js';

export default {
    name: 'home',
    components: {
        TrackList,
        LoadingIndicator,
    },
    watch: {
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.loadingTracks = true;

            api.get('/tracks', {}, {
                limit: 3
            }, (data) => {
                this.loadingTracks = false;

                if (data.success) {
                    this.tracks = data.tracks;
                }
            }, () => {
                console.log('Error!');
            });
        },
    },
    mounted() {
        this.fetchData();
    },
    data() {
        return {
            loadingTracks: true,
            tracks: []
        };
    },

}
</script>



// WEBPACK FOOTER //
// Welcome.vue?6729e4fc